import { Divider, InputAdornment, Typography } from "@mui/material"
import { SearchOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"
import { useState } from "react"

import { FilterCheckbox } from "@/components/common/Filters"
import { AerosTextField } from "@/components/UiKit"
import type { Option } from "@/types/form-fields"

interface InventoryFilterSearchableListProps<T extends string> {
  label: string
  control: any
  name: string
  values: T[]
  options: Option<T>[]
  onChange: (values: T[]) => void
  testId: string
}

export const InventoryFilterSearchableList = <T extends string>({
  label,
  control,
  name,
  values,
  options,
  onChange,
  testId,
}: InventoryFilterSearchableListProps<T>): ReactElement => {
  const [query, setQuery] = useState("")

  const filteredOptions = options.filter((option) => option.label.toLowerCase().includes(query.toLowerCase()))

  return (
    <div data-testid={testId}>
      <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
        {label}
      </Typography>
      <Divider className='mb-4' />
      <div className='flex flex-col gap-4 px-4'>
        <AerosTextField
          size='small'
          placeholder='Search...'
          value={query}
          onChange={setQuery}
          data-testid={`${testId}.search-field`}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchOutlined className='text-gray-600' />
                </InputAdornment>
              ),
            },
          }}
        />
        <div className='flex max-h-[252px] flex-col overflow-y-auto'>
          {filteredOptions.map((option) => (
            <FilterCheckbox
              key={option.value}
              control={control}
              name={name}
              value={option.value}
              values={values}
              label={option.label}
              onFilterChange={(values) => onChange(values as T[])}
              data-testid={`${testId}.option-${option.value}`}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
